<template>
  <v-menu
    ref="pickerMenu"
    v-model="internalPicker.menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="internalPicker.year"
        :label="label"
        readonly
        :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-calendar' : ''"
        clearable
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      :max="new Date().toISOString().substr(0, 10)"
      min="1900-01-01"
      @click:year="saveYear"
      v-model="internalPicker.pickedDate"
      :active-picker.sync="activePicker"
      no-title
    ></v-date-picker>
  </v-menu>
</template>

<script>

export default {
  name: 'YearPicker',
  props: {
    picker: Object,
    label: String
  },
  data: vm => ({
    activePicker: null,
    internalPicker: {},
  }),
  mounted() {
    this.internalPicker = this.picker
  },
  watch: {
    'internalPicker.year_of_build': function (val) {
      this.internalPicker.pickedDate = val
      this.$refs.pickerMenu.save(val)
    },
    'internalPicker.menu' (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  },
  methods: {
    saveYear (year, event) {
      this.internalPicker.year = year.toString()
      this.$refs.pickerMenu.save(year)
      this.activePicker = 'YEAR'
      this.internalPicker.menu = false
    }
  },
  newPickerObject: function () {
    return {
      year: '',
      menu: '',
      pickedDate: ''
    }
  }
}
</script>
